import { InjectionToken } from '@angular/core';

/**
 * 화주사별 환경 값. 공유 라이브러리는 앱의 environment를 직접 읽지 않고 이 토큰으로 받는다.
 * 앱이 app.config에서 자기 environment를 넣는다. (OVW-ARC-003 2.4, 3.1)
 */
export interface SlsNovaEnv {
  /** 시스템 코드: 서버 nova.system.code와 같은 값 (포르쉐 앱 SIL, GLV 앱 GLV) */
  novaSystemCode: string;
  /** 차량 ID2: 회사마다 쓰는 고유 번호. 쓰지 않으면 enabled를 false로 두어 화면에서 숨긴다. name은 화면에 표시할 이름이다. */
  id2: { enabled: boolean; name: string };
  /** 차량 TAG KEY(서버 필드 tagKey): 쓰지 않으면 enabled를 false로 두어 화면에서 숨긴다. name은 화면에 표시할 이름이다 (예: BMW는 RFID). */
  tagKey: { enabled: boolean; name: string };
  /** TMS DCS 조회 화면 주소 */
  tmsDcsUrl: string;
}

export const SLS_NOVA_ENV = new InjectionToken<SlsNovaEnv>('SLS_NOVA_ENV');
